import { Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { type FinanceProductFormValues } from '../ProductDetailsForm';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const LeasePurchaseResidualValue = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);
    const { values } = useFormikContext<FinanceProductFormValues>();
    const { residualValue } = values;

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.residualViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="residualValue.isViewable"
                />
            </Col>

            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.residualEditable', { returnObjects: true })}
                    disabled={!residualValue?.isViewable || disabled}
                    name="residualValue.isEditable"
                />
            </Col>
        </Row>
    );
};

export default LeasePurchaseResidualValue;
